// extracted by mini-css-extract-plugin
module.exports = {"searchbar":"SearchBar_searchbar__3KMEO","search":"SearchBar_search__1uGbo"};